import React from 'react'
import IndustrySector from '../industryComponents/IndustrySector'
import IndustryDesign from '../industryComponents/IndustryDesign'
import HomeTab from '../../home/HomeTab'
import HomeResource from '../../home/HomeResource'
import SustainabilityBanner from '../../sustainability/SustainabilityBanner'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import IndustryInvest from '../industryComponents/IndustryInvest'
import IndustryServe from '../industryComponents/IndustryServe'

const breadcrumbData = [
  {
    slug: "/",
    page: "Home",
  },
  {
    slug: "",
    page: "Industries",
  },
  {
    slug: "",
    page: "CPG & Retail",
  },
];

const bannerData = {
  img:"assets/images/cpg-retail-industry-banner.webp",
  leftHead:"CPG & Retail",
  rightHead:"Powering High-Volume Retail Operations with Precision",
  desc:"In the CPG and retail sector, speed, accuracy, real-time access to information are critical to staying competitive. Dox and Box enables businesses to manage high volumes of product, inventory, operational documents with efficiency, ensuring secure storage, streamlined workflows, instant retrieval across locations."
}

const sectorData ={
  head:"Sector Overview",
  overview:"CPG and retail organizations operate in fast-moving environments where seamless coordination across supply chains, vendors, store networks is essential. Inefficient document handling can lead to delays, errors, disruptions in operations. Dox and Box provides secure, scalable, organized document management solutions that enhance visibility, improve accuracy, ensure business continuity."
}

const designData = {
  head:"Tailored Solutions for CPG & Retail",
  img:"/assets/images/cpg-service-industry-design.webp",
  desc:[
    "We specialize in delivering structured and scalable document management systems designed to support the dynamic needs of retail and consumer goods businesses. Our solutions ensure that every document is organized, accessible, aligned with operational requirements.",
    "With a deep understanding of retail workflows, we help organizations reduce manual effort, enhance data accuracy, streamline processes across the value chain."
  ],
  list:[
    "Centralized management of product, inventory, supply chain documentation",
    "Role-based permissions for enhanced data security and control",
    "Quick and precise document retrieval",
    "Compliance-focused documentation management systems",
    "Workflow automation to boost operational productivity",
    "Scalable solutions built to support growing retail operations",
  ]
}


const tabData = [
  {
    icon: "/assets/images/home-tab-icon-1.webp",
    title: "Physical Records & Archive Management",
    heading:"Secure, Structured, Scalable Physical Record Storage",
    desc:"Managing physical documents doesn’t have to mean cluttered offices or lost files. At Dox and Box, we offer end-to-end physical records management designed to keep your documents secure, accessible, fully compliant. Our state-of-the-art archival facilities are built with strict security protocols, environmental controls, fire safety systems.",
    slug:"/physical-records-management-services",
    image:"/assets/images/home-tab-image-1.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-2.webp",
    title: "Scanning & Digitization Services",
    heading:"Transform Paper Documents into Searchable Digital Assets",
    desc:"Move beyond manual paperwork with high-precision scanning and digitization services. We convert your physical records into structured, searchable, easily accessible digital formats. Using advanced scanning technology and intelligent indexing, we ensure every document is accurately captured and categorized.",
    slug:"/digitization-services",
    image:"/assets/images/home-tab-image-2.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-3.webp",
    title: "Intelligent Document Processing & AI-driven Extraction",
    heading:"Unlock Data from Documents with AI-Powered Intelligence",
    desc:"Turn unstructured documents into actionable data with our AI-driven document processing solutions. We leverage advanced technologies like machine learning, OCR, natural language processing to extract, classify, validate information automatically. From invoices and contracts to forms and reports, our system reduces manual effort, minimizes errors, accelerates workflows. ",
    slug:"/ai-document-data-extraction",
    image:"/assets/images/home-tab-image-3.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-4.webp",
    title: "Data Governance & Compliance Platform (SaaS)",
    heading:"Ensure Compliance, Control, Visibility Across Your Data",
    desc:"In today’s regulatory landscape, managing data securely and compliantly is critical. Our SaaS-based data governance platform provides centralized control over your documents, ensuring they are stored, accessed, managed in line with industry regulations. With role-based access, audit trails, retention policy automation, businesses gain complete visibility and control over their data.",
    slug:"/data-privacy-governance-compliance-platform",
    image:"/assets/images/home-tab-image-4.webp"
  },
]


const investData = {
  head:"Why CPG & Retail Businesses Need Smart Document Management?",
  boxes:[
    {
      img:'/assets/images/cpg-service-industry-invest-1.webp',
      icon:"/assets/images/cpg-service-industry-invest-icon-1.webp",
      title:"Record Efficiency",
      desc:"Organizes retail documents for quick access and streamlined operations.",
    },
    {
      img:'/assets/images/cpg-service-industry-invest-2.webp',
      icon:"/assets/images/cpg-service-industry-invest-icon-2.webp",
      title:"Faster Operations",
      desc:"Accelerates workflows across supply chain and retail activities.",
    },
    {
      img:'/assets/images/cpg-service-industry-invest-3.webp',
      icon:"/assets/images/cpg-service-industry-invest-icon-3.webp",
      title:"Reduced Manual Work",
      desc:"Decreases paperwork and repetitive operational efforts efficiently.",
    },
    {
      img:'/assets/images/cpg-service-industry-invest-4.webp',
      icon:"/assets/images/cpg-service-industry-invest-icon-4.webp",
      title:"Secure Data Handling",
      desc:"Safeguards critical business and customer information securely.",
    },
    {
      img:'/assets/images/cpg-service-industry-invest-5.webp',
      icon:"/assets/images/cpg-service-industry-invest-icon-5.webp",
      title:"Compliance Control",
      desc:"Maintains documents in line with industry rules and requirements.",
    },
    {
      img:'/assets/images/cpg-service-industry-invest-6.webp',
      icon:"/assets/images/cpg-service-industry-invest-icon-6.webp",
      title:"Improved Visibility",
      desc:"Provides clear tracking across inventory and business processes.",
    },
  ]
}

const serveData = {
  head:"Other Industries We Serve",
  boxes:[
    {
      img:"/assets/images/cpg-industry-serve-1.webp",
      title:"Government Services",
      desc:"Government services require accuracy, security, seamless access to critical public records.",
      btnText:"Know More",
      slug:"/government-records-management-services"
    },
    {
      img:"/assets/images/cpg-industry-serve-2.webp",
      title:"Insurance Services",
      desc:"Insurance operations require accuracy, security, seamless access to policy and claims documents.",
      btnText:"Know More",
      slug:"/insurance-document-management-services"
    },
  ]
}

export default function CpgRetail() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <SustainabilityBanner data={bannerData} />
      <IndustrySector data={sectorData} />
      <IndustryDesign data = {designData}/>
      <HomeTab tabData={tabData}/>
      <HomeResource/>
      <IndustryInvest data = {investData}/>
      <IndustryServe data={serveData}/>
    </>
  )
}
